import { ContainerEnvironment } from '@fluidx/office-fluid-types';
import { getCdnBaseUrl, getFluidExperienceCdnBaseUrl } from '@fluidx/utilities';
import {
  CatalogContainerPackageName,
  Ch5ContainerPackageName,
  OfficeFluidContainerPackageName,
  OneNoteMeetingPackageName
} from './Constants';

/**
 * Gets all the domains needed to load the container in the given environment.
 * This could be used to preconnect to these critical domains ahead of time as a performance optimization.
 */
export function getAllDomainsForContainer(
  packageName: string,
  containerEnvironment: ContainerEnvironment = ContainerEnvironment.Prod
): string[] {
  switch (packageName) {
    case OfficeFluidContainerPackageName:
    case OneNoteMeetingPackageName:
      return [getCdnBaseUrl(containerEnvironment)];

    case Ch5ContainerPackageName:
    case CatalogContainerPackageName:
      return [getFluidExperienceCdnBaseUrl(containerEnvironment)];

    default:
      return [];
  }
}
